module.exports = __webpack_public_path__ + "media/images/fanclub/kv-chara-01@3x-87a38a865f2319c03a56ec5655e86f10.png";